module.exports = __webpack_public_path__ + "img/02-select-hubei.8c352c7d.png";